<template>
  <div class="chat-select-group">
    <label v-if="label" :class="['select-label', 'mb-1', labelWide]">
      {{ label }}
    </label>
    <select
      class="select-input"
      :value="modelValue"
      @change="$emit('update:modelValue', $event.target.value)"
    >
      <option v-if="placeholder" :disabled="disablePlaceholder" value="">
        {{ placeholder }}
      </option>
      <option
        v-for="(option, index) in options"
        :key="index"
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'ChatSelectBox',
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '選択してください',
    },
    labelWide: {
      type: String,
      default: '',
    },
    disablePlaceholder: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
